<template>
    <CSidebar
        position="fixed"
        :unfoldable="sidebarUnfoldable"
        :visible="!!sidebarVisible"
        :class="{show: !!sidebarVisible}"
        @visible-change="onVisibleChange"
    >
        <CSidebarBrand>
            <img :src="logoBrand" class="sidebar-brand-full">
        </CSidebarBrand>
        <div class="breadcrumbContainer">
            <AppBreadcrumb/>
        </div>
        <div class="sidebarNotifyBox">
            <div class="notifiBadge" @click="$router.push('/task-list')">
                <div class="row">
                    <div class="col-3 text-center">
                        <div>
                            <i class="ti ti-layout-list"></i>
                        </div>
                    </div>
                    <div class="col-9">
                        Ir a tareas
                    </div>
                </div>
            </div>
        </div>
        <ContainerMenu/>
        <div class="sidebarMobileActions d-lg-none">
            <div class="sidebarMobileAction" @click="openStartTask">
                <i class="ti ti-library-plus me-2"></i>{{ $t('header.iniciarTarea') }}
            </div>
            <div class="sidebarMobileAction" @click="goToProfile">
                <i class="ti ti-user-circle me-2"></i>{{ $t('header.miUsuario') }}
            </div>
            <div class="sidebarMobileAction" @click="logout">
                <i class="ti ti-lock-square-rounded-filled me-2"></i>{{ $t('header.cerrarSesion') }}
            </div>
        </div>
<!--        <CSidebarToggler
            class="d-none d-lg-flex"
            @click="$store.commit('toggleUnfoldable')"
        />-->
    </CSidebar>
</template>

<script>
import {computed} from 'vue'
import {mapGetters, mapMutations, useStore} from 'vuex'
import ContainerMenu from './ContainerMenu.vue'
import logoBrand from '@/assets/images/workflow-transdark-512.svg'
import {sygnet} from '@/assets/brand/sygnet'
import {routeLocationKey} from "vue-router";
import AppBreadcrumb from "@/components/AppBreadcrumb.vue";
import toolbox from "@/toolbox";
import {volverAlAdmin} from "@/utils/emulacion";

export default {
    name: 'AppSidebar',
    computed: {
        routeLocationKey() {
            return routeLocationKey
        }
    },
    components: {
        AppBreadcrumb,
        ContainerMenu,
    },
    setup() {
        const store = useStore()
        return {
            logoBrand,
            sygnet,
            sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
            sidebarVisible: computed(() => store.state.sidebarVisible),
        }
    },
    methods: {
        ...mapMutations(["authSetInfo"]),
        // CoreUI emite visible-change(true) espuriamente al mount cuando su watcher
        // de inViewport ve el sidebar en pantalla un instante antes que el CSS móvil
        // lo empuje fuera. Eso pintaba el backdrop al entrar en móvil. Solo aceptamos
        // el cierre explícito (false) que viene de handleHide / handleClickOutside.
        onVisibleChange(event) {
            if (event === false) {
                this.$store.commit({type: 'updateSidebarVisible', value: false});
            }
        },
        closeSidebarMobile() {
            if (window.innerWidth < 992) {
                this.$store.commit({type: 'updateSidebarVisible', value: false});
            }
        },
        openStartTask() {
            this.$store.commit('triggerStartTaskModal');
            this.closeSidebarMobile();
        },
        goToProfile() {
            this.$router.push('/mi-usuario');
            this.closeSidebarMobile();
        },
        logout() {
            const self = this;
            toolbox.doAjax('POST', 'auth/logout', {},
                function () {
                    // Cerrar sesión durante una emulación solo la termina: se vuelve al super admin
                    if ((self.$store.getters.authInfo || {}).emu) {
                        volverAlAdmin();
                        return;
                    }
                    self.authSetInfo({});
                    self.$router.push('/login');
                },
                function (response) {
                    toolbox.alert(response.msg, 'danger');
                });
        },
    },
}
</script>
